import { csCZ } from '@mui/x-date-pickers/locales';

export const czechLocale = {
  ...csCZ.components.MuiLocalizationProvider.defaultProps.localeText,
  fieldYearPlaceholder: (params: { digitAmount: number }) => 'R'.repeat(params.digitAmount),
};
